export default {
    nav: {
        home: 'Home',
        contact: 'Contact',
        about: 'About Us',
        join: 'Careers',
        dataService: 'Data Service'
    },
    button: {
        login: 'Member Login',
        logout: 'Logout',
        openLogin: 'Open Login Window'
    },
    message: {
        loginRequired: 'Please login first',
        loginStatusChanged: 'Navigation bar detected login status change:',
        debugJumpTo: '[DEBUG] jumpTo(item):',
        eventBusError: 'Event bus not registered, please add in main.js: Vue.prototype.$bus = new Vue()'
    },
    footer: {
        about: 'About Us',
        philosophy: 'Company Philosophy',
        contact: 'Contact Us',
        careers: 'Careers',
        copyright: 'Copyright © 2009-2098 www.meituodata.com All Rights Reserved.',
        icp: 'Zhejiang ICP No.20027945-1',
        phone: 'Tel: 18969418571 (WeChat same number)',
        address: 'Address: Room 1406, Jingu Building, 387 Gudun Road, Xihu District, Hangzhou'
    },
    el: {
        pagination: {
            total: 'Total {total}',        // 总计显示
            goto: 'Go to',                 // 跳转按钮
            pageClassifier: 'Page',       // 数量单位
            pageSize: '',    // 每页条数标签
            pagesize: '',    // 每页条数标签
            page_size: 'items per page',    // 每页条数标签
            currentPage: 'current page',   // 当前页标签
            prevPage: 'previous page',     // 上一页
            nextPage: 'next page',         // 下一页
            prev5: 'previous 5 pages',     // 向前5页
            next5: 'next 5 pages',         // 向后5页
            pagerCount: 'pager count'      // 页码数量
        }
    },
    home_page:{
        item_data: "Data",
        items: " Total",
        export: "export",
        export_page: "export current",
        export_all: "export all",
        export_last_time: "last modified at",
        advanced_search: "Advanced",
        advanced_search_add: "add",
        advanced_search_condition: "Condition",
        advanced_search_button: "Search",
        advanced_search_loading: "Loading"
    },
    index: {
        banner: {
            title: "Focused on Pharmaceutical Information Services",
            content: "Over 10 years of industry experience with professional data support. Global exhibition participation: CPHI, API, CAC, FIC and other international exhibitions. Professional Data Analysis: Real, effective, sincere and professional market consulting. Professional Data Services: Real, effective, sincere and professional market consulting.",
            images: [
                "/img/bg1.jpg", // 实验室场景图
                "/img/bg2.jpg", // 医药展会现场
                "/img/bg3.jpg"  // 数据分析图表
            ]
        },
        company: {
            name: "Hangzhou Meituo Pharmaceutical Technology Co., Ltd.",
            intro: "A pharmaceutical information company located in Hangzhou, by the beautiful West Lake, specializing in information data services for pharmaceuticals, pesticides, biology, chemicals, etc. We provide real, effective, sincere and professional data information and market consulting to customers at home and abroad.",
            experience: "With over 10 years of focus on the pharmaceutical and chemical industry, we have established good relations and cooperation with most domestic pharmaceutical export enterprises, and regularly participate in exhibitions such as CPHI, API, CAC, and FIC."
        },
        services: {
            title: "Core Services",
            data: {
                title: "Data Information Services",
                desc: "Provide professional data information for pharmaceutical, pesticide, biological, chemical and other industries to assist customer decision-making"
            },
            consulting: {
                title: "Market Consulting",
                desc: "Sincere and professional market analysis and consulting services to provide strategic support for enterprise development"
            },
            cooperation: {
                title: "Enterprise Cooperation Connection",
                desc: "Connect domestic and foreign pharmaceutical enterprises to promote technical exchanges and business cooperation"
            },
            exhibition: {
                title: "Exhibition Services",
                desc: "Provide international exhibition participation support to expand enterprises' global vision"
            }
        },
        exhibitions: {
            title: "International Exhibition Participation",
            cphi: {
                name: "CPHI Worldwide",
                desc: "The world's leading exhibition for pharmaceutical ingredients and manufacturing equipment"
            },
            api: {
                name: "API China",
                desc: "China's premier pharmaceutical ingredients exhibition"
            },
            cac: {
                name: "CAC Exhibition",
                desc: "The world's leading professional exhibition for agricultural chemicals"
            },
            fic: {
                name: "FIC Exhibition",
                desc: "Asia's leading professional exhibition for food additives and ingredients"
            }
        },
        clients: {
            title: "Cooperative Clients",
            desc: "Established good relations and cooperation with most domestic pharmaceutical export enterprises",
            list: ["Client Enterprise A", "Client Enterprise B", "Client Enterprise C", "Client Enterprise D", "Client Enterprise E", "Client Enterprise F"]
        },
        contact: {
            title: "Contact Us"
        }
    },
    lang: {
        'zh-CN': 'Chinese',
        'en-US': 'English'
    }
};